import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import i18next from 'i18next';
import ButtonPrimary from '../Buttons/Button';

const OnBoardingCtaContainer = styled.div`
  margin-top: 2.5rem;

  @media only screen and (max-width: 900px) {
    padding-top: 2.5rem;
    margin-top: auto;

    > button {
      max-width: 100%;
      width: 100%;
    }
  }
`;

const OnBoardingCta = ({
  onClick,
  icon,
  title = i18next.t('continue'),
  disabled,
  type = 'button',
  buttonProps,
}) => (
  <OnBoardingCtaContainer>
    <ButtonPrimary
      disabled={disabled}
      type={type}
      Icon={icon}
      title={title}
      onClick={onClick}
      {...buttonProps}
    />
  </OnBoardingCtaContainer>
);

OnBoardingCta.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.node,
  title: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  buttonProps: PropTypes.shape({
    type: PropTypes.string,
  }),
};

export default OnBoardingCta;
